<template>
  <div class="app-container excel">
    <el-table :data="list" v-loading="listLoading" fit border style="width: 100%" :row-class-name="getRowClass" :stripe="true"
      @expand-change="expandChange">
      <el-table-column label="全省食品生产经营主体及第三方冷贮服务提供者冷库数量统计表" align="center">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.areaData" border fit v-loading="innerListLoading">
              <el-table-column prop="region_name" align="center">
              </el-table-column>
              <el-table-column label="其他食品经营者" prop="type1_count" align="center">
              </el-table-column>
              <el-table-column label="餐饮企业" prop="type2_count" align="center">
              </el-table-column>
              <el-table-column label="食品加工企业" prop="type3_count" align="center">
              </el-table-column>
              <el-table-column label="食品批发企业" prop="type4_count" align="center">
              </el-table-column>
              <el-table-column label="大型超市" prop="type5_count" align="center">
              </el-table-column>
              <el-table-column label="储备商品冷库" prop="type6_count" align="center">
              </el-table-column>
              <el-table-column label="种植养殖企业合作社" prop="type7_count" align="center">
              </el-table-column>
              <el-table-column label="生鲜电商" prop="type8_count" align="center">
              </el-table-column>
              <el-table-column label="第三方冷贮服务提供者" prop="type9_count" align="center">
              </el-table-column>
              <el-table-column label="其他非食品经营者" prop="type10_count" align="center">
              </el-table-column>
              <el-table-column label="生猪屠宰场冷库" prop="type11_count" align="center">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="region_name" align="center"> </el-table-column>
        <el-table-column label="其他食品经营者" prop="type1_count" align="center">
        </el-table-column>
        <el-table-column label="餐饮企业" prop="type2_count" align="center">
        </el-table-column>
        <el-table-column label="食品加工企业" prop="type3_count" align="center">
        </el-table-column>
        <el-table-column label="食品批发企业" prop="type4_count" align="center">
        </el-table-column>
        <el-table-column label="大型超市" prop="type5_count" align="center">
        </el-table-column>
        <el-table-column label="储备商品冷库" prop="type6_count" align="center">
        </el-table-column>
        <el-table-column label="种植养殖企业合作社" prop="type7_count" align="center">
        </el-table-column>
        <el-table-column label="生鲜电商" prop="type8_count" align="center">
        </el-table-column>
        <el-table-column label="第三方冷贮服务提供者" prop="type9_count" align="center">
        </el-table-column>
        <el-table-column label="其他非食品经营者" prop="type10_count" align="center">
        </el-table-column>
        <el-table-column label="生猪屠宰场冷库" prop="type11_count" align="center">
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
import axios from "@/util/api";

export default {
  data () {
    return {
      listLoading: false,
      innerListLoading: false,
      list: [],
    };
  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      this.listLoading = true;
      axios.get("/pc/warehouse-statistics/freezerNumStatistics").then((response) => {
        let { data } = response;
        let list = data.list;
        list.map((item) => {
          if (item.region_code.length > 2) {
            item.areaData = [];
            item.areaDataFlag = false;
          }
        });
        this.list = list;
        this.listLoading = false;
      });
    },
    expandChange (row, expandedRows) {
      if (expandedRows.length > 0) {
        this.innerListLoading = true;
        axios
          .get("/pc/warehouse-statistics/freezerNumStatistics", {
            region_code: row.region_code,
          })
          .then((res) => {
            // 遍历当前页面表
            this.list.forEach((temp, index) => {
              // 找到当前点击的行，把动态获取到的数据赋值进去
              if (temp.region_code === row.region_code) {
                this.list[index].areaData = res.data.list;
              }
            });
            this.innerListLoading = false;
          });
      }
    },
    getRowClass (row, rowIndex) {
      let data = row.row.areaData;
      let res = [];
      if (data) {
        res.push("row-expand-has");
        return res;
      } else {
        res.push("row-expand-unhas");
        return res;
      }
    },
  },
};
</script>

<style>
.row-expand-unhas .el-table__expand-column {
  pointer-events: none;
}
.row-expand-unhas .el-table__expand-column .el-icon {
  visibility: hidden;
}
.excel .el-table__expanded-cell {
  background-color: rgb(217, 236, 255);
}
</style>
